import React, { useState, useRef } from "react"
import classnames from "@utils/classnames"
import Section from "@components/section"
import Title from "@components/title"
import ColTitle from "@components/colTitle"
import ModalSection from "@components/modalSection"
import FrameLogos from "@components/frameLogos"
import Button from "@components/button"
import Frame from "@components/frame"
import Logos from "@components/logos"
import Modal from "@components/modal"
import Slider from "@components/slider"
import styles from "./challengeGames.module.scss"

import arrowImage from "@images/arrow-down.png"
import game3Img from "@images/logos/game-3.png"
import game4Img from "@images/logos/game-4.png"
import game6Img from "@images/logos/game-6.png"

import coinStep1Image from "@images/challenge-games/coin-step1.png"
import coinStep2Image from "@images/challenge-games/coin-step2.png"
import coinStep3Image from "@images/challenge-games/coin-step3.png"
import coinAward1Image from "@images/challenge-games/coin-award1.png"
import coinAward2Image from "@images/challenge-games/coin-award2.png"
import coinAward3Image from "@images/challenge-games/coin-award3.png"
import coinAward4Image from "@images/challenge-games/coin-award4.png"
import hellStep1Image from "@images/challenge-games/hell-step1.png"
import hellStep2Image from "@images/challenge-games/hell-step2.png"

const ITEMS = [
  {
    key: "coin",
    title: "金币挑战规则",
    en: (
      <>
        COIN
        <br />
        CHALLENGE
      </>
    ),
    desc: "玩游戏，拿大奖",
  },
  {
    key: "hell",
    title: "地狱挑战规则",
    en: (
      <>
        HELL
        <br />
        CHALLENGE
      </>
    ),
    desc: (
      <>
        0.1%通过率
        <br />
        赢次世代全家桶
      </>
    ),
  },
  {
    key: "games",
  },
]

const COL_ITEMS = ITEMS.filter(i => i.title)

const renderModalSection = (title, body) => {
  return <ModalSection title={title}>{body}</ModalSection>
}

const renderModalCol = (title, desc, image) => {
  return (
    <div className={styles.modalCol}>
      <div>
        <h4>{title}</h4>
        <p>{desc}</p>
      </div>
      <img src={image} alt={title} />
    </div>
  )
}

const renderCoinBody = () => {
  return (
    <>
      {renderModalSection(
        "金币挑战规则",
        <div className={styles.coinSteps}>
          {renderModalCol("STEP 1", "进场领取入场手册", coinStep1Image)}
          <div className={styles.coinStepsArrow}>
            <img src={arrowImage} alt="next" />
          </div>
          {renderModalCol("STEP 2", "参与游戏，获得金币盖章", coinStep2Image)}
          <div className={styles.coinStepsArrow}>
            <img src={arrowImage} alt="next" />
          </div>
          {renderModalCol("STEP 3", "利用金币盖章，兑换奖品", coinStep3Image)}
        </div>
      )}
      {renderModalSection(
        "金币挑战奖品",
        <div className={styles.coinAwards}>
          {renderModalCol("三金币", "核聚变纪念徽章", coinAward1Image)}
          {renderModalCol(
            "六金币",
            "水壶+海报+核聚变纪念徽章",
            coinAward2Image
          )}
          {renderModalCol(
            "九金币",
            "衣服/背包/XGP卡/艺术集/手柄/音响+水壶+海报+徽章",
            coinAward3Image
          )}
          {renderModalCol(
            "九金币+任一地狱挑战",
            <>NSL/电视/耳机/加速器/街机摇杆/手柄+衣服+水壶+海报+徽章</>,
            coinAward4Image
          )}
        </div>
      )}
      <p className="textCenter fontSm">（数量有限，先到先得）</p>
    </>
  )
}

const renderHellBody = () => {
  return renderModalSection(
    "地狱挑战规则",
    <div className={styles.hellRules}>
      {renderModalCol("STEP 1", "全场四个地狱挑战游戏全天开放", hellStep1Image)}
      {renderModalCol(
        "STEP 2",
        <>
          如果是首位通关玩家，将获得4K电视、PS5、XSX、NS各一台！
          <br />
          另外每月还可获得任意一款游戏（共十二个月，平台任选，不含限定版）
        </>,
        hellStep2Image
      )}
    </div>
  )
}

const renderGamesBody = () => {
  return (
    <>
      {renderModalSection(
        "金币游戏区",
        <div className={styles.indieGames}>
          <Logos
            total={6}
            urlPrefix="https://site.gcores.com/assets/fusion2021/coin/coin"
          />
        </div>
      )}
      {renderModalSection(
        "独立游戏区",
        <div className={styles.indieGames}>
          <p>
            今年独立游戏区再度扩大，现场将有36个团队带着他们的游戏来到现场，期待我们在现场一起交流。
          </p>
          <Logos
            total={36}
            urlPrefix="https://site.gcores.com/assets/fusion2021/indie/indie"
          />
        </div>
      )}
    </>
  )
}

const ModalBody = ({ type, closeModal }) => {
  const sliderRef = useRef(null)

  if (!type) {
    return null
  }

  return (
    <Slider
      ref={sliderRef}
      data={ITEMS}
      renderItem={({ key }) => {
        if (key === "coin") {
          return renderCoinBody()
        } else if (key === "hell") {
          return renderHellBody()
        } else if (key === "games") {
          return renderGamesBody()
        }
        return null
      }}
      initialSlide={ITEMS.map(i => i.key).indexOf(type)}
      onClose={closeModal}
    />
  )
}

const ChallengeGames = React.memo(props => {
  const [currentSelected, setCurrentSelected] = useState(null)
  const closeModal = () => {
    setCurrentSelected(null)
  }
  return (
    <Section>
      <Modal isOpen={currentSelected !== null} onRequestClose={closeModal}>
        <ModalBody type={currentSelected} closeModal={closeModal} />
      </Modal>
      <Title en="CHALLENGE GAMES">经典玩法，加量不加价</Title>
      <Frame.OutlineContainer className={styles.container}>
        {COL_ITEMS.map(({ title, en, desc, key }) => {
          return (
            <Frame
              onClick={() => {
                setCurrentSelected(key)
              }}
              className={styles.item}
              withArrow
            >
              <ColTitle sub={en}>{title}</ColTitle>
              <p>{desc}</p>
            </Frame>
          )
        })}
      </Frame.OutlineContainer>
      <FrameLogos
        title="金币与独立游戏列表"
        sub="GAME LIST"
        desc=""
        logos={[game3Img, game4Img, game6Img]}
        onClick={() => {
          setCurrentSelected("games")
        }}
      />
    </Section>
  )
})

ChallengeGames.displayName = "ChallengeGames"
export default ChallengeGames
